import React, { createContext, useContext, useState } from "react";
import { useQuery } from "react-query";

import ImgProfile from "../../assets/prof-pic.png";

import { fetchCanAccess } from "../../services/GeneralRegistration/getCanAccess";
import { fetchCanRegistrationTypes } from "../../services/GeneralRegistration/getCanRegistrationTypes";
import { format, parseISO } from "date-fns";
import { toast } from "react-toastify";
import { api } from "../../utils/api";
import { cancelBond } from "../../services/GeneralRegistration/postCancelBond";
import { getUsers } from "../../services/GeneralRegistration/getUsers";
import { useForm } from "react-hook-form";
import { useAppContext } from "../../context/AppContext";
import { useParams } from "react-router-dom";

const RequiredContext = createContext();

export const RequiredProvider = ({ children }) => {
  const { hash, role } = useParams();
  const isPublic = hash ? true : false;
  // console.log("isPublic Required: ", isPublic);
  const { permissions } = useAppContext();
  const [file, setFile] = useState(""); // state que armazena arquivos (fotos,docs)
  const [bond, setBond] = useState({});
  const [address, setAddress] = useState({});
  const [isSaved, setIsSaved] = useState(false);
  const [emailSend, setEmailSend] = useState(false);
  const [emailVerify, setEmailVerify] = useState(false);
  const [filePreview, setFilePreview] = useState(ImgProfile);

  const [baseData, setBaseData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [typeRegister, setTypeRegister] = useState("fisica");

  const [conjuge, setConjuge] = useState([]);
  const [formData, setFormData] = useState({});
  const [addSpouse, setAddSpouse] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const [newClient, setNewClient] = useState(null);

  const [inputRequireds, setInputRequireds] = useState([]);
  const [showInputCreci, setShowInputCreci] = useState(false);
  const [showStatusUser, setShowStatusUser] = useState(false);
  const [showInputPassword, setShowInputPassword] = useState(false);
  const [requiredEmail, setRequiredEmail] = useState(false);

  const [errors, setErrors] = useState(null);
  const [loading, setloading] = useState(false);
  const [errorsVisible, setErrorsVisible] = useState(false);
  const [cpf, setCpf] = useState("");
  const [proofResidence, setProofResidence] = useState("");
  const [socialContract, setSocialContract] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [docSelected, setDocSelected] = useState("");
  const [selectedDocId, setSelectedDocId] = useState(null);
  const [clientVisible, setClientVisible] = useState(false);
  const [idClientEdit, setIdClientEdit] = useState();

  // Telefones dos Usuários
  const [contacts, setContacts] = useState([]);
  const [telephones, setTelephones] = useState([{}]);

  const form = useForm({
    shouldUnregister: false,
  });

  const testDate = (date) => {
    if (date && typeof date === "string") {
      return format(parseISO(date), "yyyy-MM-dd");
    } else if (date && typeof date !== "string") {
      return format(date, "yyyy-MM-dd");
    } else {
      return "";
    }
  };

  const updateTableData = (newData, id) => {
    const updateData = [...tableData];
    const selectedUser = updateData.findIndex((item) => item.id === id);
    updateData[selectedUser].name = newData.name;
    updateData[selectedUser].email = newData.email;
    updateData[selectedUser].doc = newData.doc;
    updateData[selectedUser].type_doc = newData.type_doc;
    updateData[selectedUser].contacts = newData.contacts
      ? newData.contacts.map((c) => c.number)
      : "";
    updateData[selectedUser].registration_types = typesregistrationMultiSelect
      .map((type) => {
        if (newData.registration_types.includes(type.code)) {
          return type.name;
        }
      })
      .filter((t) => t !== undefined)
      .toString();
    if (newData.access) {
      updateData[selectedUser].role = canAccess.find(
        (a) => a.value === newData.access.role_id
      ).label;
    }
    setTableData(updateData);
  };

  const handleNext = (data) => {
    setFormData(data);
  };

  const handlePrevious = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  const { data: typesregistrationQuery, isLoading: loadingTypes } = useQuery({
    queryKey: ["canRegistrationTypes"],
    queryFn: () => fetchCanRegistrationTypes(),
    enabled: (((isPublic && !role || isPublic && role === "undefined") || isPublic && role === "Cliente")) ? false : true,
  });

  const typesregistrationSelect = typesregistrationQuery
    ? typesregistrationQuery.data?.map((dado) => ({
      label: dado.name,
      value: dado.id,
    }))
    : [];

  const typesregistrationMultiSelect = typesregistrationQuery
    ? typesregistrationQuery.data?.map((dado) => ({
      name: dado.name,
      code: dado.id,
    }))
    : [];

  const { data: canAccessQuery, isLoading: loadingCanAccess } = useQuery({
    queryKey: ["canAccess"],
    queryFn: () => fetchCanAccess(),
    enabled: (((isPublic && !role || isPublic && role === "undefined") || isPublic && role === "Cliente")) ? false : true,
  });

  const canAccess = canAccessQuery
    ? canAccessQuery.data?.map((dado) => ({
      value: dado.id,
      label: dado.name,
    }))
    : [];

  const handleAccessChange = (e) => {
    // const selectedOption = canAccess.find((option) => option.value === e);
    // if ((e) && !baseData) setShowInputPassword(true);
    // else setShowInputPassword(false);
    if (e) setRequiredEmail(true);
    else setRequiredEmail(false);
  };

  const handleRegistrationTypesChange = async (e) => {
    const auxTypeRegister = e.some(
      (item) => item.code === 1 || item.code === 2 || item.code === 8
    );

    const itemsSelected = e.map((item) => {
      return item.name;
    });

    if (
      itemsSelected.includes("Corretor") ||
      itemsSelected.includes("Imobiliária")
    ) {
      setShowInputCreci(true);
    } else {
      setShowInputCreci(false);
    }

    if (auxTypeRegister) {
      var auxRegisterGeneral = localStorage.getItem("registerGeneral");
      setInputRequireds(auxRegisterGeneral);
      localStorage.setItem("required_registerGeneral", true);
    } else {
      setInputRequireds([]);
      localStorage.setItem("required_registerGeneral", false);
    }
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const base64Data = event.target.result;
        resolve(reader.result);
        return base64Data;
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  };

  const photoUpload = async (e) => {
    // e.preventDefault();
    let files = e.target ? e.target.files : e.files;
    if (!files || files.length === 0) {
      return;
    }
    const file = files[0];
    try {
      const res = await readFileAsBase64(file);
      return res;
    } catch (error) {
      console.error("Error reading file:", error);
    }
  };

  const handleFileChange = async (e) => {
    // console.log("selected", docSelected);
    const res = await photoUpload(e);
    // console.log(res);

    if (isEdit) {
      const doc = documents.find((item) => item.id === selectedDocId);
      setDocuments(
        documents.map((d) => {
          if (d.id === doc.id) {
            //            // console.log(d);
            return {
              id: doc.id,
              name: doc.name,
              type_file: `cadastro_geral_${docSelected}`,
              file: res,
            };
          } else {
            return {
              id: d.id,
              name: d.name,
              type_file: d.type_file,
              ...(d.path || d.file ? { path: d.path, file: d.file } : {}),
            };
          }
        })
      );
    } else {
      switch (docSelected) {
        case "cpf":
          setCpf(res);
          break;
        case "proof_residence":
          setProofResidence(res);
          break;
        case "social_contract":
          setSocialContract(res);
          break;
        default:
          break;
      }
    }
  };

  function getFalseBondIds(data) {
    return Object.keys(data)
      .filter((key) => key.startsWith("bond_id-") && data[key] === false)
      .map((key) => key.split("-")[1]); // Extrai apenas o ID numérico
  }

  function removeBondIds(data) {
    Object.keys(data).forEach((key) => {
      if (key.startsWith("bond_id-")) {
        delete data[key];
      }
    });
  }

  const onClose = () => {
    setClientVisible(false);
    setIdClientEdit();
  };

  const handleClickEditErrors = (form) => {
    console.log(errors);
    if (errors.email) {
      setActiveIndex(0);
      form.setError("email");
      setErrorsVisible(false);
    } else if (errors.name) {
      setActiveIndex(1);
      form.setError("name");
      setErrorsVisible(false);
    } else if (errors.doc) {
      setActiveIndex(1);
      form.setError("doc");
      setErrorsVisible(false);
    } else if (
      errors.rg ||
      errors.profession ||
      errors.name_father ||
      errors.name_mother ||
      errors.nationality ||
      errors.date_of_birth ||
      errors.family_income ||
      errors.issuing_authority ||
      errors.date_issuing_authority ||
      errors["contacts.0.type_number"] ||
      errors["contacts.1.type_number"] ||
      errors["contacts.2.type_number"]
    ) {
      setActiveIndex(1);
      setErrorsVisible(false);
    } else if (errors.contacts || errors.obs || errors.creci) {
      setActiveIndex(1);
      setErrorsVisible(false);
    } else if (errors.documents) {
      setActiveIndex(3);
      setErrorsVisible(false);
    } else if (
      errors["addresses.complement"] ||
      errors["addresses.address"] ||
      errors["addresses.neighborhood"] ||
      errors["addresses.city"] ||
      errors["addresses.num"] ||
      errors["addresses.state"] ||
      errors["addresses.cep"]
    ) {
      setActiveIndex(2);
      setErrorsVisible(false);
    }
  };

  const handleEdit = async (data) => {
    setloading(true);
    let objBond;

    if(form.getValues(`confirmEmail`) || form.getValues(`email`)){
      if (form.getValues(`confirmEmail`) !== form.getValues(`email`)) {
        toast.error("Os E-mail's devem ser iguais!");
        setloading(false);
        return;
      }
    }

    const notification = toast.loading("Por favor aguarde...");

    if (permissions && permissions.includes("8")) {
      const falseBondIds = getFalseBondIds(data);
      objBond = {
        ids: falseBondIds,
      };

      if (falseBondIds.length > 0) {
        cancelBond(objBond);
      }

      removeBondIds(data);
    }

    if (data.registration_types !== undefined) {
      const codesArray = data.registration_types.map((item) => item.code);
      data.registration_types = codesArray;
    }

    if (data.access_id) {
      data.role_id = data.access_id;
    }

    if (data.status) {
      data.status = 1;
    } else {
      data.status = 0;
    }

    if (data.date_of_birth) {
      const birthDate = testDate(data.date_of_birth);
      data.date_of_birth = birthDate;
    }

    if (data.date_issuing_authority) {
      const issuingDate = testDate(data.date_issuing_authority);
      data.date_issuing_authority = issuingDate;
    }

    // data.contacts = data.contacts.filter(Boolean);
    if (data.contacts?.length === 0) {
      delete data.contacts;
    }

    // console.log(telephones);
    const tel = telephones.filter(
      (i) => i.number !== "" && Object.keys(i).length !== 0
    );
    // console.log(tel);
    if (tel.length === 0) {
      delete data.contacts;
    } else {
      data.contacts = tel.map((item) => {
        return {
          number: item.number,
          type_number: item.type_number,
        };
      });
    }

    // console.log("telephones", telephones);

    // console.log("contacts", data.contacts);

    if (data.documents === undefined) {
      data.documents = [];
    }

    if (Array.isArray(documents) && documents.length !== 0) {
      // documents.map(i => data.documents.push(i))
      documents.map((item) => {
        item.type_file = item.type_file.replace("cadastro_geral_", "");
        if (typeof item.id === "string") {
          //          // console.log(item);
          delete item.id;
        }
        return item;
      });
      // console.log(documents);
      data.documents = data.documents.concat(documents);
      // data.documents.push(documents);
    }

    if (file !== undefined && file !== "") {
      const profileIndex = data.documents.findIndex(
        (doc) => doc.type_file === "profile_photo" || doc.type_file === "cadastro_geral_profile_photo"
      );
      // console.log(profileIndex);

      if (profileIndex !== -1) {
        const profile = data.documents[profileIndex];

        // console.log(profile);
        data.documents[profileIndex] = {
          id: profile.id,
          name: "Perfil",
          type_file: "cadastro_geral_profile_photo",
          file: file,
        };
      } else {
        data.documents.push({
          name: "Perfil",
          type_file: "cadastro_geral_profile_photo",
          file: file,
        });
      }
    }

    if (cpf) {
      const existingDocument = documents.find(
        (document) => document.type_file === "cpf"
      );
      if (existingDocument) {
        existingDocument.file = cpf;
        setDocuments([...documents]);
      } else {
        data.documents.push({ name: "CPF", type_file: "cpf", file: cpf });
        setDocuments([
          ...documents,
          { name: "CPF", type_file: "cpf", file: cpf },
        ]);
      }
    }

    if (proofResidence) {
      const existingDocument = documents.find(
        (document) => document.type_file === "proof_residence"
      );
      if (existingDocument) {
        existingDocument.file = proofResidence;
        setDocuments([...documents]);
      } else {
        data.documents.push({
          name: "Comp. Residência",
          type_file: "proof_residence",
          file: proofResidence,
        });
        setDocuments([
          ...documents,
          {
            name: "Comp. Residência",
            type_file: "proof_residence",
            file: proofResidence,
          },
        ]);
      }
    }

    if (socialContract) {
      const existingDocument = documents.find(
        (document) => document.type_file === "social_contract"
      );
      if (existingDocument) {
        existingDocument.file = socialContract;
        setDocuments([...documents]);
      } else {
        data.documents.push({
          name: "Contrato Social",
          type_file: "social_contract",
          file: socialContract,
        });
        setDocuments([
          ...documents,
          {
            name: "Contrato Social",
            type_file: "social_contract",
            file: socialContract,
          },
        ]);
      }
    }

    // console.log(data.documents);

    if (
      data.cep !== undefined ||
      data.address !== undefined ||
      data.num !== undefined ||
      data.neighborhood !== undefined ||
      data.city !== undefined ||
      data.state !== undefined ||
      data.complement !== undefined
    ) {
      data.addresses = {
        cep: data.cep,
        address: data.address,
        num: data.num,
        neighborhood: data.neighborhood,
        city: data.city,
        state: data.state,
        complement: data.complement,
      };
    }

    delete data.access_id;
    delete data.profile_photo;
    delete data.contacts_conjuge;
    delete data.number_conjuge;
    delete data.tel_conjuge;
    delete data.password;
    delete data.confirmPassword;
    delete data.confirmEmail;
    delete data.cep;
    delete data.address;
    delete data.num;
    delete data.neighborhood;
    delete data.city;
    delete data.state;
    delete data.spouse;
    delete data.complement;
    delete data.name_conjuge;
    delete data.doc_conjuge;
    delete data.rg_conjuge;
    delete data.date_of_birth_conjuge;
    delete data.email_conjuge;
    delete data.profession_conjuge;
    delete data.name_mother_conjuge;
    delete data.name_father_conjuge;
    delete data.issuing_authority_conjuge;
    delete data.nationality_conjuge;
    delete data.obs_conjuge;
    delete data.type_numbers;

    try {
      const response = await api.put(`register-general/${idClientEdit}`, data);
      // console.log(response);
      updateTableData(data, idClientEdit);
      if (response.data) {
        toast.update(notification, {
          render: response.data.success,
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      }

      if (activeIndex >= 3) {
        onClose();
        setActiveIndex(0);
        setDocuments([]);
        setConjuge("");
        setBaseData();
        setShowInputPassword(false);
        setEmailVerify(false);
        setEmailSend(false);
        setRequiredEmail(false);
        setShowStatusUser(false);
        setShowInputCreci(false);
        setSocialContract("");
        setProofResidence("");
        setCpf("");
        setAddSpouse(false);
        setTelephones([{}]);
        setIsSaved(false);
        setAddress({});
        setContacts([]);
        form.reset();
      }
      setIsSaved(true);
      setloading(false);
    } catch (error) {
      setloading(false);
      setErrors(error?.response.data.errors);
      setErrorsVisible(true);
      toast.update(notification, {
        render: "Falha ao salvar informações!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
        isLoading: false,
      });
    }
  };

  return (
    <RequiredContext.Provider
      value={{
        form,
        inputRequireds,
        setInputRequireds,
        formData,
        setFormData,
        activeIndex,
        setActiveIndex,
        handleNext,
        showInputCreci,
        setShowInputCreci,
        showInputPassword,
        setShowInputPassword,
        handlePrevious,
        handleAccessChange,
        handleRegistrationTypesChange,
        typesregistrationSelect,
        typesregistrationMultiSelect,
        loadingTypes,
        canAccess,
        loadingCanAccess,
        file,
        setFile,
        conjuge,
        setConjuge,
        filePreview,
        setFilePreview,
        newClient,
        setNewClient,
        tableData,
        setTableData,
        telephones,
        setTelephones,
        addSpouse,
        setAddSpouse,
        documents,
        setDocuments,
        typeRegister,
        setTypeRegister,
        contacts,
        setContacts,
        address,
        setAddress,
        bond,
        setBond,
        showStatusUser,
        setShowStatusUser,
        baseData,
        setBaseData,
        requiredEmail,
        setRequiredEmail,
        emailVerify,
        setEmailVerify,
        emailSend,
        setEmailSend,
        errors,
        setErrors,
        loading,
        setloading,
        errorsVisible,
        setErrorsVisible,
        handleClickEditErrors,
        handleEdit,
        cpf,
        setCpf,
        proofResidence,
        setProofResidence,
        socialContract,
        setSocialContract,
        isEdit,
        setIsEdit,
        docSelected,
        setDocSelected,
        selectedDocId,
        setSelectedDocId,
        clientVisible,
        setClientVisible,
        idClientEdit,
        setIdClientEdit,
        handleFileChange,
        onClose,
        isSaved,
        setIsSaved,
      }}
    >
      {children}
    </RequiredContext.Provider>
  );
};

export const useRequired = () => {
  return useContext(RequiredContext);
};
